import React, { type ReactElement } from 'react'
import certifications from '../../assets/images/Certificados.svg'
import styles from './Certifications.module.scss'

function Certifications (): ReactElement {
  return <div className={styles.container}>
    <div className={styles.header}>
      <h2>¡Espéralo pronto!</h2>
      <p>En esta sección podrás gestionar tus certificados laborales.</p>
    </div>
    <div className={styles.content}>
      <img
        src={certifications}
        alt="Imagen de certificaciones"
        className={styles.imgMobil}
      />
    </div>
  </div>
}

export default Certifications
